<template>
  <el-dialog
    v-drag
    v-loading="loading"
    title="更新其他信息"
    :visible.sync="dialogVisible"
    width="690px"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
  >
    <div class="content">
      <el-form ref="form" :model="form" label-position="top">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="注册时间" prop="registerDate">
              <el-date-picker
                v-model="form.registerDate"
                style="width: 100%"
                type="date"
                align="center"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="生效日期" prop="effectiveDate">
              <el-date-picker
                v-model="form.effectiveDate"
                style="width: 100%"
                type="date"
                align="center"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="截止时间" prop="closeDate">
              <el-date-picker
                v-model="form.closeDate"
                style="width: 100%"
                type="date"
                align="center"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="报税截止时间" prop="bondedDeadlineDate">
              <el-date-picker
                v-model="form.bondedDeadlineDate"
                style="width: 100%"
                type="date"
                align="center"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="年审截止时间" prop="yearAuditDeadlineDate">
              <el-date-picker
                v-model="form.yearAuditDeadlineDate"
                style="width: 100%"
                type="date"
                align="center"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="BOI是否" prop="isBOI">
              <el-select v-model="form.isBOI" placeholder="请选择" clearable>
                <el-option label="是" :value="true"></el-option>
                <el-option label="否" :value="false"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="月结是否" prop="isMonthEnd">
              <el-select
                v-model="form.isMonthEnd"
                placeholder="请选择"
                clearable
              >
                <el-option label="是" :value="true"></el-option>
                <el-option label="否" :value="false"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="是否敏感进口商" prop="isSensitiveImporter">
              <el-select
                v-model="form.isSensitiveImporter"
                placeholder="请选择"
                clearable
              >
                <el-option label="是" :value="true"></el-option>
                <el-option label="否" :value="false"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="是否注销" prop="isCancel">
              <el-select
                v-model="form.isCancel"
                placeholder="请选择"
                clearable
                @change="form.cancelDate = null"
              >
                <el-option label="是" :value="true"></el-option>
                <el-option label="否" :value="false"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col v-if="form.isCancel" :span="8">
            <el-form-item label="注销时间" prop="cancelDate">
              <el-date-picker
                v-model="form.cancelDate"
                style="width: 100%"
                type="date"
                align="center"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="是否禁用" prop="isActived">
              <el-switch
                v-model="form.isActived"
                :active-text="form.isActived ? '是' : '否'"
              >
              </el-switch>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <span slot="footer" class="footers flex_c_c">
      <div class="cancel flex_c_c" @click="cancel">取消</div>
      <div v-debounce-click="{ value: ok, args: ['form'] }" class="ok flex_c_c">
        确定
      </div>
    </span>
  </el-dialog>
</template>

<script>
import { batchUpdateOther } from '@/api/system'
export default {
  props: {
    dialogVisible: Boolean,
    selectionItem: Array
  },
  data() {
    return {
      loading: false,
      form: {
        registerDate: null,
        closeDate: null,
        bondedDeadlineDate: null,
        yearAuditDeadlineDate: null,
        isBOI: null,
        isMonthEnd: null,
        isActived: null,
        isSensitiveImporter: null,
        isCancel: null,
        cancelDate: null,
        effectiveDate: null
      }
    }
  },
  watch: {
    dialogVisible(v) {
      if (v) {
        this.reset()
      }
    }
  },
  methods: {
    reset() {
      this.form = this.$options.data().form
      this.$refs.form?.resetFields()
    },
    cancel() {
      this.$emit('cancel')
    },
    ok(formName) {
      this.$refs[formName].validate(async(valid) => {
        if (valid) {
          this.loading = true
          try {
            const params = {
              importerIds: this.selectionItem.map((a) => a.id),
              ...this.form
            }
            const res = await batchUpdateOther(params)
            this.loading = false
            if (res.success) {
              this.$message.success(res.errorMessage)
              this.$emit('ok')
            } else {
              this.$message.error(res.errorMessage)
            }
          } catch (error) {
            this.loading = false
            console.error(error)
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  width: 100%;
  margin: 0 auto;
  /deep/ .el-form--label-top .el-form-item__label {
    line-height: 30px;
    padding: 0;
  }
}
.footers {
  width: 100%;
  & > div {
    width: 120px;
    height: 40px;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    cursor: pointer;
  }
  .cancel {
    background: #eeeeee;
    color: #666666;
    margin-right: 16px;
  }
  .ok {
    background: #142e79;
    color: #ffffff;
  }
}
</style>
